import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=5d13d2f7&scoped=true"
import script from "./page-footer.vue?vue&type=script&lang=js"
export * from "./page-footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d13d2f7",
  null
  
)

export default component.exports